// extracted by mini-css-extract-plugin
export default {"option":"_3h8TaE1M","isSelected":"smgxbDUl","colorList":"_3CWXrtw8","colorItem":"tYlvzbl3"};